// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"227ac8e9","136":"6c18bb93","227":"227ac8e9","494":"7d943a34","524":"7d943a34","737":"227ac8e9","820":"03729192","851":"a49fe01f","987":"94a3bd9a"}[chunkId] + ".chunk.css";
};